"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TimeSeriesData_1 = __importDefault(require("../entity/TimeSeriesData"));
const TimeSeriesStub_1 = __importDefault(require("./TimeSeriesStub"));
const luxon_1 = require("luxon");
class TimeSeriesDataStub extends TimeSeriesData_1.default {
    constructor({ label = 'ABC', values = [
        new TimeSeriesStub_1.default({
            datetime: luxon_1.DateTime.fromISO('2019-01-01T00:00:00'),
            value: 10,
        }),
    ], } = {}) {
        super({ label, values });
    }
}
exports.default = TimeSeriesDataStub;
